import { render, staticRenderFns } from "./NavBarList.vue?vue&type=template&id=2636c982&scoped=true&"
import script from "./NavBarList.vue?vue&type=script&lang=js&"
export * from "./NavBarList.vue?vue&type=script&lang=js&"
import style0 from "./NavBarList.vue?vue&type=style&index=0&id=2636c982&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2636c982",
  null
  
)

export default component.exports